import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';

import { AuthUtils } from 'app/core/auth/auth.utils';
import { Common } from 'app/modules/_common/service';
import { SearchPeopleType } from 'app/modules/teams/people/people.type';

@Injectable({providedIn: 'root'})
export class TeamPeopleService
{
    get BASEURL(): string
    {
        return environment.api.replace("[hostinglocation]", AuthUtils.hostingLocation) + '/api/v2/';
        //return environment.api.replace("[hostinglocation]", AuthUtils.hostingLocation) + '/api/';
    }

    constructor(private _httpClient: HttpClient)
    {
    }

    //
    public getPeoples_PageSize: number = 30;
    private _peoples: BehaviorSubject<any[] | null> = new BehaviorSubject(null);

    get getPeoples$(): Observable<any[]>
    {
        return this._peoples.asObservable();
    }
    getPeoples(page: number, pageSize: number, q: SearchPeopleType, p: string = ''): Observable<any[]>
    {        
        return this._httpClient.get<any>(`${this.BASEURL}teams/person/paged/list?page=${page}&pageSize=${pageSize}&take=${pageSize}&skip=0&searchTerm=${q.searchTerm ?? ``}&displayNameStartsWith=${q.displayNameStartsWith ?? ``}&isActiveOnly=${q.isActiveOnly ?? true}${Object.hasOwn(q, `isFavourite`) ? `&isFavourite=${q.isFavourite}` : ``}&isGroupByDepartment=${q.isGroupByDepartment ?? false}${p ? `${p}`:``}`).pipe(
            catchError(Common.CatchError),
            tap(({ data }) =>
            {
                this._peoples.next(data);
            })
        );

        //return this._httpClient.get<any>(`${this.BASEURL}person/paged/searchuri?groupByAttributeId=&isGroupByDepartment=${isGroupByDepartment}&take=30&skip=0&page=1&pageSize=30`).pipe(
        //    tap(({ data }) =>
        //    {
        //        this._peoples.next(data);
        //    })
        //);
    }
    //

    //
    private _person: BehaviorSubject<any | null> = new BehaviorSubject(null);

    get getPerson$(): Observable<any>
    {
        return this._person.asObservable();
    }
    getPerson(displayName, personId): Observable<any>
    {
        return this._httpClient.get<any>(`${this.BASEURL}attribute/GetAttributesByItemId/person/${personId}`).pipe(
            catchError(Common.CatchError),
            tap((data) =>
            {
                if (data) data._displayName = displayName;

                this._person.next(data);
            })
        );
    }
    //

    //
    private _getPersonReservation: BehaviorSubject<any | null> = new BehaviorSubject(null);

    get getPersonReservation$(): Observable<any>
    {
        return this._getPersonReservation.asObservable();
    }
    getPersonReservation(personId, selectedDateLocal: string = null): Observable<any>
    {
        return this._httpClient.get<any>(`${this.BASEURL}asset/reservations/personattribute/${personId}?${selectedDateLocal ? `selectedDateLocal=${selectedDateLocal}` : ``}`).pipe(
            catchError(Common.CatchError),
            tap((data) =>
            {
                this._getPersonReservation.next(data);
            })
        );
    }
    //

    //
    _personPhotoData = [];
    getPersonPhoto(personId): Observable<any>
    {
        const q = this._personPhotoData.find(r => r.personId == personId);
        if (q) {
            return of(q.image);
        }

        return this._httpClient.get<any>(`${this.BASEURL}person/${personId}/filebase64`).pipe(
            map((base64) =>
            {
                const q = this._personPhotoData.find(r => r.personId == personId);
                if (q) {
                    return of(q.image);
                }

                const img = base64 ? `data:image/png;base64, ${base64}` : null;
                this._personPhotoData.push({personId: personId, image: img});

                return img;
            }),
            catchError(Common.CatchError)
        );
    }
    //

    addFavourite(personId, isFavourite): Observable<any> {
        if (isFavourite) {
            return this._httpClient.post<any>(`${this.BASEURL}favourite/person/${personId}`, {}).pipe(
                catchError(Common.CatchError)
            );
        } else {
            return this._httpClient.delete<any>(`${this.BASEURL}favourite/person/${personId}`).pipe(
                catchError(Common.CatchError)
            );
        }
    }


    //
    private _getPeopleFilterAttributes: BehaviorSubject<any | null> = new BehaviorSubject(null);

    get getPeopleFilterAttributes$(): Observable<any>
    {
        return this._getPeopleFilterAttributes.asObservable();
    }
    getPeopleFilterAttributes(): Observable<any>
    {
        return this._httpClient.get<any>(`${this.BASEURL}attribute/getAllByType/people?fieldtype=boolean`).pipe(
            catchError(Common.CatchError),
            map((data) =>
            {
                var list = [];

                //list.push({ attributeId: '00000000-0000-0000-0000-000000000000', name: 'Show All', selected: false });
                //list.push({ attributeId: '00000000-0000-0000-0000-000000000001', name: 'Department', selected: false });

                for (var i = 0; i < data.length; i++) {
                    list.push({ attributeId: data[i].attributeId, name: data[i].name, selected: false });
                }

                this._getPeopleFilterAttributes.next(list);

                return list;
            })
        );
    }
    //

    //
    private _getDepartments: BehaviorSubject<any | null> = new BehaviorSubject(null);

    get getDepartments$(): Observable<any>
    {
        return this._getDepartments.asObservable();
    }
    getDepartments(): Observable<any>
    {
        return this._httpClient.get<any>(`${this.BASEURL}department/list`).pipe(
            catchError(Common.CatchError),
            map((data) =>
            {
                var list = [];

                for (var i = 0; i < data.length; i++) {
                    list.push({ departmentId: data[i].departmentId, name: data[i].name, selected: false });
                }

                this._getDepartments.next(list);

                return list;
            })
        );
    }
    //

    /**
     * Update person's work day plan
     */

    private _updatePersonWorkDays: BehaviorSubject<null> = new BehaviorSubject(null);

    get updatePersonWorkDays$(): Observable<any[]>
    {
        return this._updatePersonWorkDays.asObservable();
    }        
    updatePersonWorkDays(personId: string, workDayData: any): Observable<any> {
        return this._httpClient.put<any>(`${this.BASEURL}person/${personId}`, workDayData).pipe(
            tap((response) => {
                // Optionally refresh the person data
                this._updatePersonWorkDays.next(null);
            }),
            catchError((error) => {
                console.error('Error updating work day plan:', error);
                throw error;
            })
        );
    }
}
